<template>
  <div class="meter-reading">
    <a-row :gutter="16" style="height: 100%">
      <!-- 左侧栏 - 35% + 30% + 35% -->
      <a-col :span="6" style="height: 100%">
        <a-row :gutter="16" style="height: 35%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('物联网设备分析')">
              <FaultAnalysis ref="faultAnalysisRef" />
            </DataContainer>
          </a-col>
        </a-row>
        <a-row :gutter="16" style="height: 30%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('水表规格与在线统计')">
              <MeterReadingSizeMeterNumAndOnline ref="meterReadingSizeMeterNumAndOnlineRef" />
            </DataContainer>
          </a-col>
        </a-row>
        <a-row :gutter="16" style="height: 35%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('小区远传表近7日抄见率')">
              <MeterCommunityRate ref="meterCommunityRateRef" />
            </DataContainer>
          </a-col>
        </a-row>
      </a-col>

      <!-- 中间栏 - 65% + 35% -->
      <a-col :span="12" style="height: 100%">
        <a-row :gutter="16" style="height: 65%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('抄表中心')">
              <MeterReadingCenter ref="meterReadingCenterRef" />
            </DataContainer>
          </a-col>
        </a-row>
        <a-row :gutter="16" style="height: 35%">
          <a-col :span="12" style="height: 100%">
            <DataContainer :title="$t('厂家水表统计')">
              <MeterManufacturerTotal ref="meterManufacturerTotalRef" />
            </DataContainer>
          </a-col>
          <a-col :span="12" style="height: 100%">
            <DataContainer :title="$t('厂家水表在线率')">
              <MeterReadingOnlineAndFault ref="meterReadingOnlineAndFaultRef" />
            </DataContainer>
          </a-col>
        </a-row>
      </a-col>

      <!-- 右侧栏 - 33% + 32% + 35% -->
      <a-col :span="6" style="height: 100%">
        <a-row :gutter="16" style="height: 33%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('抄表指标')">
              <MeterReadingIndex ref="meterReadingIndexRef" />
            </DataContainer>
          </a-col>
        </a-row>
        <a-row :gutter="16" style="height: 32%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('大用户水表')">
              <MeterReadingLargeUsers ref="meterReadingLargeUsersRef" />
            </DataContainer>
          </a-col>
        </a-row>
        <a-row :gutter="16" style="height: 35%">
          <a-col :span="24" style="height: 100%">
            <DataContainer :title="$t('实时告警')">
              <MeterRealTimeAlarmList ref="meterRealTimeAlarmListRef" />
            </DataContainer>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import DataContainer from './DataContainer.vue'
import FaultAnalysis from './modules/meterReading/FaultAnalysis.vue'
import MeterReadingSizeMeterNumAndOnline from './modules/meterReading/MeterReadingSizeMeterNumAndOnline.vue'
import MeterCommunityRate from './modules/meterReading/MeterCommunityRate.vue'
import MeterReadingCenter from './modules/meterReading/MeterReadingCenter.vue'
import MeterManufacturerTotal from './modules/meterReading/MeterManufacturerTotal.vue'
import MeterReadingOnlineAndFault from './modules/meterReading/MeterReadingOnlineAndFault.vue'
import MeterReadingIndex from './modules/meterReading/MeterReadingIndex.vue'
import MeterReadingLargeUsers from './modules/meterReading/MeterReadingLargeUsers.vue'
import MeterRealTimeAlarmList from './modules/meterReading/MeterRealTimeAlarmList.vue'

export default {
  name: 'MeterReading',
  components: {
    DataContainer,
    FaultAnalysis,
    MeterReadingSizeMeterNumAndOnline,
    MeterCommunityRate,
    MeterReadingCenter,
    MeterManufacturerTotal,
    MeterReadingOnlineAndFault,
    MeterReadingIndex,
    MeterReadingLargeUsers,
    MeterRealTimeAlarmList
  },
  data() {
    return {
      titleImage: require('@/assets/images/title-gradual.png')
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    init() {
      this.$refs.faultAnalysisRef.init()
      this.$refs.meterReadingSizeMeterNumAndOnlineRef.init()
      this.$refs.meterCommunityRateRef.init()
      this.$refs.meterReadingCenterRef.init()
      this.$refs.meterManufacturerTotalRef.init()
      this.$refs.meterReadingOnlineAndFaultRef.init()
      this.$refs.meterReadingIndexRef.init()
      this.$refs.meterReadingLargeUsersRef.init()
      this.$refs.meterRealTimeAlarmListRef.init()
    }
  }
}
</script>

<style lang="less" scoped>
.meter-reading {
  width: 100%;
  height: 100%;
  // padding: 16px;
  color: #ffffff;
  overflow: hidden;
}

// 响应式设计
@media (max-width: 1440px) {
  .meter-reading {
    // padding: 12px;
  }
}

@media (max-width: 1200px) {
  .meter-reading {
    // padding: 8px;
  }
}
</style>